define(['text!./templates/mfp-partner-data.html',
], (templateStr) => {

    return ['MFPPartnerService', 'ContextService', (MFPPartnerService, ContextService) => {
        return {
            restrict: 'EA',
            scope: {
                partnerData: '=', //view model
                empMode: '=',
                brandCode: '=',
            },
            template: templateStr,
            controller: ['$scope', ($scope) => {

                // 'Ich bin':
                $scope.onCreatedByDealerChange = (newValue) => {
                    if (newValue) {
                        // defaults for Handler
                        $scope.partnerData.value.isSelectedDealer = true;
                        $scope.partnerData.value.dealerContact = {};
                    } else {
                        // defaults for Customer
                        $scope.partnerData.value.isSelectedDealer = true;
                        $scope.partnerData.value.sellerNumber = null;
                        $scope.partnerData.value.email = null;
                        $scope.partnerData.value.dealerContact = {}; //provide validations
                    }
                };


                // 'Ich habe':
                $scope.onSelectedDealerChange = (newValue) => {
                    if (newValue) {
                        // default for DealerContact selected
                        $scope.partnerData.value.dealerContact = {}; //provide validations
                    } else {
                        // defaults for no DealerContact selected
                        $scope.partnerData.value.sellerNumber = null;
                        $scope.partnerData.value.email = null;
                        $scope.partnerData.value.dealerContact = null;
                    }
                };

                // VISIBLE FN
                $scope.showIsCreatedByDealer = () => {
                    // shown not for PartnerLeasing Product
                    return MFPPartnerService.showIsCreatedByDealer($scope.empMode);
                };

                $scope.showIsSelectedDealer = () => {
                    // shown for Customer only
                    return MFPPartnerService.showIsSelectedDealer($scope.partnerData.isCreatedByDealer.value);
                };

                $scope.showDealerSelection = () => {
                    // shown for:
                    // a Customer, when dealer is selected,
                    // a Handler,
                    return MFPPartnerService.showDealerSelection(
                        $scope.empMode,
                        $scope.partnerData.isSelectedDealer.value,
                        $scope.partnerData.isCreatedByDealer.value
                    );
                };

                $scope.showAddonHandlerFields = () => {
                    // shown for :
                    // employee mode for a customer when a dealer is selected
                    // employee mode for a dealer
                    // non-employee mode only for a dealer
                    return MFPPartnerService.showAddonHandlerFields(
                        $scope.empMode,
                        $scope.partnerData.isSelectedDealer.value,
                        $scope.partnerData.isCreatedByDealer.value
                    );
                };

                $scope.showDealerIsEmployer = () => {
                    // shown for :
                    // employee mode for a customer when a dealer is selected
                    // employee mode for a dealer
                    return MFPPartnerService.showDealerIsEmployer(
                        $scope.empMode,
                        $scope.partnerData.isSelectedDealer.value
                    );
                };

                $scope.iAmLabelKeys = ContextService.isEmployeeMode() ? {
                        labelKey: 'quoteandbind.mfp.directives.templates.mfp-partner-data.EmployeeMode.Iam',
                        noKey: 'quoteandbind.mfp.directives.templates.mfp-partner-data.EmployeeMode.Iam.No',
                        yesKey: 'quoteandbind.mfp.directives.templates.mfp-partner-data.EmployeeMode.Iam.Yes',
                    } : {
                        labelKey: 'quoteandbind.mfp.directives.templates.mfp-partner-data.CreatedByDealer',
                        noKey: 'quoteandbind.mfp.directives.templates.mfp-partner-data.CreatedByDealer.No',
                        yesKey: 'quoteandbind.mfp.directives.templates.mfp-partner-data.CreatedByDealer.Yes',
                    }
                ;

                $scope.showSellerNumber = () => {
                    // shown if Dealer is selected in non-employee mode
                    return MFPPartnerService.showSellerNumber(
                        $scope.partnerData.isSelectedDealer.value
                    );
                };

                $scope.showSellerEmail = () => {
                    // shown for :
                    // employee mode for a dealer
                    // non-employee mode only for a dealer
                    return MFPPartnerService.showSellerEmail(
                        $scope.partnerData.isCreatedByDealer.value
                    );
                };

                $scope.getSellerNumberLabelKey = () => {
                    return MFPPartnerService.getSellerNumberLabelKey(ContextService.getChannel());
                };

                // Initialization:
                $scope.partnerData.isCreatedByDealer.value = true

            }],
        };
    }];

});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPPartnerData.js